import { Collection } from 'caldera-immutable-model';

import CollaboratorInvite from './CollaboratorInvite';

export default class CollaboratorInviteCollection extends Collection {
  static Model = CollaboratorInvite;

  uniqByEmail(): CollaboratorInviteCollection {
    return this.uniqBy(invite => invite.email);
  }
}



// WEBPACK FOOTER //
// ./src/models/CollaboratorInviteCollection.js